// https://stackoverflow.com/questions/27078285/simple-throttle-in-js
export function throttle(callback, limit) {
    var waiting = false;
    return function () {
        if (!waiting) {
            callback.apply(this, arguments);
            waiting = true;
            setTimeout(function () {
                waiting = false;
            }, limit);
        }
    }
}

export function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
}

export function isEscape(e) {
    // keyCode is getting deprecated use key instead when supported, which makes this messy
    var evt = e || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = (evt.key == "Escape" || evt.key == "Esc");
    } else {
        isEscape = (evt.keyCode == 27);
    }
    return isEscape;
}

export function trapFocus(trap, focusFirst = true) {
    const focusableElements = 'button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"]), iframe';
    const firstFocusableElement = trap.querySelectorAll(focusableElements)[0]; // get first element to be focused inside trap
    const focusableContent = trap.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside trap
    const onKeyDown = function (e) {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    };
    document.addEventListener('keydown', onKeyDown);
    if (focusFirst) {
        setTimeout(() => {
            firstFocusableElement.focus();
        }, 350);
    }
    return () => document.removeEventListener('keydown', onKeyDown);
}

export function returnFocus() {
    if (typeof window.returnFocusTo !== 'undefined') {
        window.returnFocusTo.focus();
    }
}

export function getElementIndex(element) {
    if (!element || !element.parentElement) {
        return -1; // Or handle error appropriately
    }
    // Get all direct child elements of the parent
    const siblings = Array.from(element.parentElement.children);
    // Find the index of the element within that list
    return siblings.indexOf(element);
}

export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function formatPrice(format, priceInCents) {
    return format.replace(
        "{{amount}}",
        numberWithCommas((priceInCents / 100).toFixed(2))
    );
}
